<script setup>
const config = useRuntimeConfig()
const localePath = useLocalePath()
const props = defineProps({ blok: Object })
const getPath = (item) => localePath('blog')+'?category='+translatedPath(item.full_slug)
const categories = props.blok.filter(x=>x.uuid !== config.public.blog.categoryUUID )
</script>
<template>
	<div v-if="categories" class="flex flex-row gap-3 pt-4">
		<NuxtLink v-for="cat in categories" 
			:to="getPath(cat)"
			:style="`background-color:${cat.content.color.color}`"
			class="text-xs px-3 py-2 text-newdark-800 rounded-full">{{ cat.content.name }}</NuxtLink>
	</div>
</template>